$(document).ready(function (){

    /*Слайдер товары недели*/
    $('.sliderFourProductsWeek').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 993,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 4,
                }
            }
        ]
    });
});
